import { render } from "./vueHeader.vue?vue&type=template&id=e2dec896&scoped=true"
import script from "./vueHeader.vue?vue&type=script&lang=js"
export * from "./vueHeader.vue?vue&type=script&lang=js"

import "./vueHeader.vue?vue&type=style&index=0&id=e2dec896&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2dec896"]])

export default __exports__